var SessionTimeoutWarningModal = (function() {
  var countdownInterval = null;
  var currentCountdown = 0;
  var isVisible = false;

  var MODAL_ID = '#sessionTimeoutWarningModal';
  var COUNTDOWN_VALUE_ID = '#sessionTimeoutCountdownValue';
  var COUNTDOWN_LABEL_ID = '#sessionTimeoutCountdownLabel';
  var STAY_BTN_ID = '#sessionTimeoutStayBtn';
  var LOGOUT_BTN_ID = '#sessionTimeoutLogoutBtn';
  var LIVE_REGION_ID = '#sessionTimeoutLiveRegion';

  var SCREEN_READER_ANNOUNCE_AT = [10];

  function show(seconds) {
    if (isVisible) {
      updateCountdown(seconds);
      return;
    }

    var $modal = $(MODAL_ID);
    if ($modal.length === 0) {
      return;
    }

    currentCountdown = seconds || 30;
    updateCountdownDisplay();
    bindButtonHandlers();
    startCountdown();

    $modal.one('shown.bs.modal', function() {
      announceToScreenReader(
        'Session Timeout Warning. Your session is about to expire due to inactivity. ' +
        'You will be logged out in ' + currentCountdown + ' seconds. ' +
        'Press Stay Logged In to continue.'
      );
    });

    $modal.modal('show');
    isVisible = true;
  }

  function hide() {
    var $modal = $(MODAL_ID);
    if ($modal.length > 0) {
      $modal.modal('hide');
    }
    stopCountdown();
    clearLiveRegion();
    isVisible = false;
    resetStayButton();
  }

  function bindButtonHandlers() {
    $(STAY_BTN_ID).off('click.sessionTimeout').on('click.sessionTimeout', handleStayLoggedIn);
    $(LOGOUT_BTN_ID).off('click.sessionTimeout').on('click.sessionTimeout', handleLogout);
  }

  // --- Screen reader announcements ---

  function announceToScreenReader(message) {
    var $region = $(LIVE_REGION_ID);
    if ($region.length > 0) {
      $region.text('');
      setTimeout(function() { $region.text(message); }, 50);
    }
  }

  function clearLiveRegion() {
    var $region = $(LIVE_REGION_ID);
    if ($region.length > 0) {
      $region.text('');
    }
  }

  function shouldAnnounce(seconds) {
    for (var i = 0; i < SCREEN_READER_ANNOUNCE_AT.length; i++) {
      if (seconds === SCREEN_READER_ANNOUNCE_AT[i]) { return true; }
    }
    return false;
  }

  // --- Core countdown logic ---

  function handleStayLoggedIn() {
    var $btn = $(STAY_BTN_ID);
    $btn.prop('disabled', true).text('Extending...');

    if (window.sessionActivityTracker) {
      window.sessionActivityTracker.lastActivityTime = Date.now();
      window.sessionActivityTracker.sendHeartbeat('modal_stay_logged_in', true)
        .then(function() {
          window.sessionActivityTracker.resume();
          hide();
        })
        .catch(function(status) {
          if (status === 401) {
            window.location = '/timeout?logout=true';
          } else {
            resetStayButton();
          }
        });
    }
  }

  function resetStayButton() {
    $(STAY_BTN_ID).prop('disabled', false).text('Stay Logged In');
  }

  function handleLogout() {
    window.location = '/timeout?logout=true';
  }

  function updateCountdown(seconds) {
    currentCountdown = seconds;
    updateCountdownDisplay();
  }

  function startCountdown() {
    stopCountdown();

    countdownInterval = setInterval(function() {
      currentCountdown--;

      if (currentCountdown <= 0) {
        stopCountdown();
        window.location = '/timeout?logout=true';
      } else {
        updateCountdownDisplay();

        if (shouldAnnounce(currentCountdown)) {
          var label = currentCountdown === 1 ? 'second' : 'seconds';
          announceToScreenReader(currentCountdown + ' ' + label + ' remaining');
        }
      }
    }, 1000);
  }

  function stopCountdown() {
    if (countdownInterval) {
      clearInterval(countdownInterval);
      countdownInterval = null;
    }
  }

  function updateCountdownDisplay() {
    var $value = $(COUNTDOWN_VALUE_ID);
    var $label = $(COUNTDOWN_LABEL_ID);

    if ($value.length > 0) {
      $value.text(currentCountdown);
    }

    if ($label.length > 0) {
      $label.text(currentCountdown === 1 ? 'second' : 'seconds');
    }
  }

  function getStatus() {
    return {
      isVisible: isVisible,
      currentCountdown: currentCountdown
    };
  }

  return {
    show: show,
    hide: hide,
    updateCountdown: updateCountdown,
    getStatus: getStatus
  };
})();

window.SessionTimeoutWarningModal = SessionTimeoutWarningModal;
